import React, { useContext, useEffect, useState } from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import { TableContext } from "../index";
import { useHistory } from "react-router-dom";
import * as urlService from "../view/urlService";
import { exportRecentViolationData } from "../rules/ruleService";
import ChooseDeviceField from "./ChooseDeviceField";
import TimeIntervalDropdown from "./TimeIntervalDropdown";
import SearchInputV2 from "../view/SearchInputV2";
import Select from 'react-select';
import { Download } from "lucide-react";

function RecentViolationsTableHeader({ currentUser }) {
    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const [showRemediateLabel, setShowRemediateLabel] = useState('Show Remediated');

    const refreshOptions = [
        { value: 0, label: 'Off' },
        { value: 5, label: '5 sec' },
        { value: 15, label: '15 sec' },
        { value: 30, label: '30 sec' },
        { value: 60, label: '60 sec' },
        { value: 300, label: '300 sec' }
    ];

    const [refreshInterval, setRefreshInterval] = useState(() => {
        try {
            const key = `recentViolationsRefreshInterval_${currentUser || 'default'}`;
            const saved = window.localStorage.getItem(key);
            return saved !== null ? Number(saved) : 0;
        } catch (err) {
            return 0;
        }
    });

    useEffect(() => {
        try {
            const key = `recentViolationsRefreshInterval_${currentUser || 'default'}`;
            window.localStorage.setItem(key, String(refreshInterval));
        } catch (err) {
            // ignore
        }
    }, [refreshInterval, currentUser]);

    useEffect(() => {
        if (!refreshInterval || refreshInterval <= 0) {
            return;
        }

        const intervalId = setInterval(() => {
            if (document.visibilityState !== 'visible') {
                return;
            }
            setConfig((prevConfig) => ({ ...prevConfig, lastUpdated: Date.now() }));
        }, refreshInterval * 1000);

        return () => clearInterval(intervalId);
    }, [refreshInterval, setConfig]);

    // Search state
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    };

    const exportData = () => {
        exportRecentViolationData();
    }

    const onShowRemediatedClick = () => {
        if (showRemediateLabel === 'Show Remediated') {
            setShowRemediateLabel('Show Violations');
            setConfig({ ...config, showRemediated: true });
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('remediated')
            })
            history.push({
                pathname: history.pathname,
                search: urlService.updateComparisonFilters('remediated', 1)
            })
        } else {
            setShowRemediateLabel('Show Remediated');
            setConfig({ ...config, showRemediated: false });
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('remediated')
            })
            history.push({
                pathname: history.pathname,
                search: urlService.updateComparisonFilters('remediated', 0)
            })
        }
    }


    return (
        <>
            {/* Row 1: Filters + Buttons */}
            <div className="oct_filter-section-v2">
                <div className="row align-items-end">
                    <div className="col">
                        <label className="oct_filter-label">DEVICE</label>
                        <ChooseDeviceField />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">TIME INTERVAL</label>
                        <TimeIntervalDropdown />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">Auto refresh</label>
                        <Select
                            className="oct_selectsearch-v2"
                            classNamePrefix="oct-selectsearchsub-v2"
                            value={refreshOptions.find(opt => opt.value === refreshInterval) || refreshOptions.find(opt => opt.value === 0)}
                            onChange={(selectedOption) => setRefreshInterval(selectedOption.value)}
                            options={refreshOptions}
                            isSearchable={false}
                            placeholder="Set time interval"
                        />
                    </div>

                    <div className="col d-flex justify-content-end ">
                        <button onClick={onShowRemediatedClick}
                            className="oct_btn-outline-v2 mr-2">
                            {showRemediateLabel}
                        </button>
                        <button onClick={exportData} className="oct_btn-export-v2">
                            <Download className="oct_icon" />
                            Export Data
                        </button>
                    </div>
                </div>

                {/* Row 2: Search */}
                <div className="mt-3">
                    <SearchInputV2
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search by device name or severity"
                        className="m-0"
                    />
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    debug("RecentViolationsTableHeader mapStateToProps", state);
    const auth = state.auth;
    const recentViolationsPage = state.recentViolationsPage;
    const metadata = recentViolationsPage.metadata || {};
    const validationResultList = recentViolationsPage.validationResultList || [];

    return {
        whitelisted: metadata.whitelisted || 0,
        validationResultList,
        currentUser: auth.firstName + ' ' + auth.lastName
    }
}


export default connect(mapStateToProps)(RecentViolationsTableHeader);
